import { render, staticRenderFns } from "./driver-list.vue?vue&type=template&id=f2dda4ba"
import script from "./driver-list.vue?vue&type=script&lang=js"
export * from "./driver-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports